import Box from "@mui/material/Box";
import { Outlet } from "react-router-dom";
import { getTokenClaims } from "../../core/auth/auth";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

const AppShell = () => {
  const claims = getTokenClaims();

  if (!claims) return null;

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar claims={claims} />
      <Box sx={{ display: "flex", flexDirection: "column", flex: 1, overflow: "hidden" }}>
        <Topbar claims={claims} />
        <Box
          component="main"
          sx={{
            flex: 1,
            overflow: "auto",
            p: 3,
            bgcolor: "var(--color-bg)",
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AppShell;
